import { render, staticRenderFns } from "./SaleStock.vue?vue&type=template&id=6b458eac&scoped=true"
import script from "./SaleStock.vue?vue&type=script&lang=js"
export * from "./SaleStock.vue?vue&type=script&lang=js"
import style0 from "./SaleStock.vue?vue&type=style&index=0&id=6b458eac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b458eac",
  null
  
)

export default component.exports